import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import ResetPassword from './views/ResetPassword.vue'
import ForgetPassword from './views/ForgetPassword.vue'

Vue.use(Router);

const _Router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: `/`,
      name: "login",
      component: Login
    },
    {
      path: `/register`,
      name: "register",
      component: Register
    },
    {
      path: `/forget_password`,
      name: "forget_password",
      component: ForgetPassword
    },
    {
      path: `/reset_password`,
      name: "reset_password",
      component: ResetPassword
    }
  ]
});

export default _Router